var _rect, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthSearchCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 360",
    role: "img",
    "aria-label": "HealthSearch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 360,
    fill: "#0f193d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 60,
    r: 140,
    fill: "#f07364",
    opacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 330,
    r: 120,
    fill: "#f07364",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250 175)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 78,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 56,
    x2: 118,
    y2: 118,
    stroke: "#ffffff",
    strokeWidth: 22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -44,
    width: 24,
    height: 88,
    rx: 5,
    fill: "#f07364"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -12,
    width: 88,
    height: 24,
    rx: 5,
    fill: "#f07364"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSearchCard);
export default __webpack_public_path__ + "static/media/HealthSearch_Card.0b59ed8928aaee1b2d4464e1e1e857d1.svg";
export { ForwardRef as ReactComponent };